module.exports = __webpack_public_path__ + "img/John_Basich.a99081d.png";